<!DOCTYPE html>
<html lang=$global.lang||"en" data-markopress-base-path="">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>${$global.title || 'Priestch'}</title>
  <if=$global.description>
    <meta name="description" content=$global.description>
  </if>
  <theme-head-top/>
  <meta name="theme-color" content="#3c8772">
  <link rel="stylesheet" href="/_markopress/theme/theme-default.css">
  <link rel="stylesheet" href="/_markopress/theme/styles.css">
  
  <theme-head-bottom/>
</head>
<body>
  <theme-doc-top/>
  <div class="app-container">
    <!-- Navbar -->
    <nav class="navbar">
      <div class="navbar-container">
        <a href="/" class="navbar-brand">
          <span class="navbar-title">Priestch</span>
        </a>
        <theme-navbar-start/>
        <theme-navbar-center items=$global.navbar/>
        <theme-navbar-end/>
      </div>
    </nav>

    <!-- Main content area with optional sidebar -->
    <div class=["main-wrapper", $global.sidebar && "has-sidebar"]>
      <if=$global.sidebar>
        <!-- Sidebar for docs -->
        <aside class="sidebar desktop-only">
          <theme-sidebar-top/>
          <sidebar sections=$global.sidebar/>
          <theme-sidebar-bottom/>
        </aside>
      </if>

      <!-- Page content -->
      <main class="main-content">
        <theme-page-top/>
        <${input.content}/>
        <theme-page-bottom/>
      </main>
    </div>

    <!-- Footer -->
    <footer class="footer">
      <div class="footer-container">
        <if=$global.footer>
          <p>${$global.footer.message || ''}</p>
          <p>${$global.footer.copyright || ''}</p>
        </if>
      </div>
    </footer>
  </div>
  <theme-doc-bottom/>
  <theme-body-bottom/>
</body>
</html>
